import React, {Component} from 'react';
import axios from 'axios';

class SiteTracking extends Component{
	constructor(props){
		super(props);
		this.state={
			loadTime:new Date()
		}
	}

	componentDidMount(){
		this.saveTrackingData(this.props.action,this.props.data);
		document.addEventListener("visibilitychange", ()=>{
			if (document.visibilityState === 'hidden') {
				navigator.sendBeacon(window.global.content_hub.API+'tracking/duration?updateID='+this.state.updateID+'&duration='+(new Date()-this.state.loadTime));
			}
		});
	}

	componentWillUnmount(){
		if(this.props.duration===true){
			this.updateDuration();
		}
		this.unmounted=true;
	}

	updateDuration=async()=>{
		if(this.unmounted!==true)
			await axios.post(window.global.content_hub.API+'tracking/duration?updateID='+this.state.updateID+'&duration='+(new Date()-this.state.loadTime));
		}

	saveTrackingData=async()=>{
		let result=await axios.post(window.global.content_hub.API+'tracking/save',{
			action:this.props.action,
			data:this.props.data
		});
		if(result.data.status==='success' && result.data.updateID!==undefined){
			let data={updateID:result.data.updateID};
			this.setState(data);
		}
	}

	render(){ 
		return (<React.Fragment>
			{this.props.children}			
		</React.Fragment>);
	}
}
 
export default SiteTracking;